import type { ProductGroupsData } from './picker-forest'

import { useMemo } from 'react'

import { useDryCategoriesQuery, useProductGroupsQuery } from '../../api/queries'
import { buildPickerForest } from './picker-forest'

/** Composes the PG and category queries into the catalog + picker forest. */
export const useProductGroupCatalogQuery = (): {
	data: ProductGroupsData | undefined
	isLoading: boolean
} => {
	const productGroupsQuery = useProductGroupsQuery({
		include_full_categories: true,
	})
	const categoriesQuery = useDryCategoriesQuery()
	const data = useMemo(
		() =>
			productGroupsQuery.data && categoriesQuery.data
				? buildPickerForest(categoriesQuery.data, productGroupsQuery.data)
				: undefined,
		[productGroupsQuery.data, categoriesQuery.data]
	)

	return {
		data,
		isLoading: productGroupsQuery.isLoading || categoriesQuery.isLoading,
	}
}
